// extracted by mini-css-extract-plugin
export default {"root":"EditFlagForm_root__x0sxi","form":"EditFlagForm_form__S49bY","after":"EditFlagForm_after__fQLKR"};